import {
  RESET_CHANGE_DISPLAY_NAME_OBJ,
  RESET_CHANGE_DISPLAY_NAME_STATUS,
  CHANGE_DISPLAY_NAME_ERROR,
  CHANGE_DISPLAY_NAME,
  CHANGED_DISPLAY_NAME,
} from "./actionTypes";

export const resetChangeDisplayNameObj = () => {
  return {
    type: RESET_CHANGE_DISPLAY_NAME_OBJ,
    payload: {},
  };
};
export const resetChangeDisplayNameStatus = (reset) => {
  return {
    type: RESET_CHANGE_DISPLAY_NAME_STATUS,
    payload: reset,
  };
};
export const changeDisplayNameError = (error) => {
  return {
    type: CHANGE_DISPLAY_NAME_ERROR,
    payload: error,
  };
};

export const changeDisplayName = (chatId, chatDisplayName) => {
  return {
    type: CHANGE_DISPLAY_NAME,
    payload: { chatId, chatDisplayName },
  };
};
export const changedDisplayName = (data) => {
  return {
    type: CHANGED_DISPLAY_NAME,
    payload: data,
  };
};
